import { render, staticRenderFns } from "./TinyInfoTotalOpenPurchases.vue?vue&type=template&id=2aeb4dfd"
import script from "./TinyInfoTotalOpenPurchases.vue?vue&type=script&lang=ts"
export * from "./TinyInfoTotalOpenPurchases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aeb4dfd')) {
      api.createRecord('2aeb4dfd', component.options)
    } else {
      api.reload('2aeb4dfd', component.options)
    }
    module.hot.accept("./TinyInfoTotalOpenPurchases.vue?vue&type=template&id=2aeb4dfd", function () {
      api.rerender('2aeb4dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfoTotalOpenPurchases.vue"
export default component.exports